import React from "react";
import Banner from "../components/Banner";
import Navbar from "../components/Navbar";
import DontMiss from "../components/Welcome/DontMiss";
import HeroGrid from "../components/Welcome/HeroGrid";
import SubHeading from "../components/SubHeading";
import Trending from "../components/Welcome/Trending";
import BlackBar from "./../components/BlackBar";
import LifeStyle from "../components/Welcome/LifeStyle";
import StayConnected from "../components/Welcome/StayConnected";
import MakeItModern from "../components/Welcome/MakeItModern";
import Performance from "../components/Welcome/Performance";
import LatestArticles from "../components/Welcome/LatestArticles";
import MostPopular from "../components/Welcome/MostPopular";
import RecentComments from "../components/RecentComments";
import Footer from "../components/Footer";

function Welcome() {
  return (
    <>
      <BlackBar />
      <Banner />
      <Navbar />
      <Trending />
      <HeroGrid />

      <div className="w-full bg-green- my-10">
        <div className="w-full md:w-10/12 lg:w-7/12 mx-auto bg-red- flex flex-col md:flex-row">
          {/* LEFT HAND SECTION OF WELCOME PAGE */}
          <div className="w-full md:w-8/12 bg-blue- md:mr-10 ">
            <DontMiss />
            <LifeStyle />
            <Performance />
            <LatestArticles />
          </div>

          {/* RIGHT HAND SECTION OF WELCOME PAGE */}
          <div className="w-full md:w-4/12 bg-yellow-">
            <StayConnected />
            <div className="w-full py-6">
              <img
                className="mx-auto"
                src="https://demo.tagdiv.com/newspaper_pro/wp-content/uploads/2019/08/newspaper-rec300c.jpg"
              />
            </div>

            <MakeItModern />
            <div className="w-full py-6">
              <img
                className="mx-auto"
                src="https://demo.tagdiv.com/newspaper_pro/wp-content/uploads/2019/08/newspaper-rec300c.jpg"
              />
            </div>

            <MostPopular />
            <RecentComments />
          </div>
        </div>
      </div>
      <Footer />

    </>
  );
}

export default Welcome;
